import type { AxModelInfo } from '../types.js';

import { AxAIGoogleGeminiEmbedModel, AxAIGoogleGeminiModel } from './types.js';

/**
 * AxAIGoogleGemini: Model information
 */
export const axModelInfoGoogleGemini: AxModelInfo[] = [
  {
    name: AxAIGoogleGeminiEmbedModel.GeminiEmbedding2,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.2,
    contextWindow: 8192,
  },
  {
    name: AxAIGoogleGeminiEmbedModel.GeminiEmbedding001,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.15,
  },
  {
    name: AxAIGoogleGeminiModel.Gemini38Flash,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 1.5,
    completionTokenCostPer1M: 7.5,
    cacheReadTokenCostPer1M: 0.15,
    cacheWriteTokenCostPer1M: 1.5,
    contextWindow: 1_048_576,
    maxTokens: 65_536,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
    notSupported: { temperature: true, topP: true },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini37Flash,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 1.5,
    completionTokenCostPer1M: 7.5,
    cacheReadTokenCostPer1M: 0.15,
    cacheWriteTokenCostPer1M: 1.5,
    contextWindow: 1_048_576,
    maxTokens: 65_536,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
    notSupported: { temperature: true, topP: true },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini36Flash,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 1.5,
    completionTokenCostPer1M: 7.5,
    cacheReadTokenCostPer1M: 0.15,
    cacheWriteTokenCostPer1M: 1.5,
    contextWindow: 1_048_576,
    maxTokens: 65_536,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
    notSupported: { temperature: true, topP: true },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini35Flash,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 1.5,
    completionTokenCostPer1M: 9.0,
    cacheReadTokenCostPer1M: 0.15,
    cacheWriteTokenCostPer1M: 1.5,
    contextWindow: 1_048_576,
    maxTokens: 65_536,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini35FlashLite,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.3,
    completionTokenCostPer1M: 2.5,
    cacheReadTokenCostPer1M: 0.03,
    cacheWriteTokenCostPer1M: 0.3,
    contextWindow: 1_048_576,
    maxTokens: 65_536,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
    notSupported: { temperature: true, topP: true },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini3Pro,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 2.0,
    completionTokenCostPer1M: 12.0,
    cacheReadTokenCostPer1M: 0.2,
    cacheWriteTokenCostPer1M: 2.0,
    longContextThreshold: 200_000,
    longContextPromptTokenCostPer1M: 4.0,
    longContextCompletionTokenCostPer1M: 18.0,
    longContextCacheReadTokenCostPer1M: 0.4,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini3Flash,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.5,
    completionTokenCostPer1M: 3.0,
    cacheReadTokenCostPer1M: 0.05,
    cacheWriteTokenCostPer1M: 0.5,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini31FlashLite,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.25,
    completionTokenCostPer1M: 1.5,
    cacheReadTokenCostPer1M: 0.025,
    cacheWriteTokenCostPer1M: 0.25,
    contextWindow: 1_048_576,
    maxTokens: 65_536,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini3FlashLite,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.25,
    completionTokenCostPer1M: 1.5,
    cacheReadTokenCostPer1M: 0.025,
    cacheWriteTokenCostPer1M: 0.25,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini3ProImage,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 2.0,
    completionTokenCostPer1M: 0.134, // Per image output, approximate
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini31FlashImage,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.5,
    completionTokenCostPer1M: 3.0,
    supported: { structuredOutputs: true },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini31FlashLive,
    characterIsToken: false,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
    },
    audio: { input: true, output: true },
    contextWindow: 131_072,
    maxTokens: 65_536,
  },
  {
    name: AxAIGoogleGeminiModel.Gemini31FlashTTS,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.5,
    completionTokenCostPer1M: 3.0,
    audio: { input: false, output: true },
  },
  {
    name: AxAIGoogleGeminiModel.NanoBanana2,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.5,
    completionTokenCostPer1M: 3.0,
  },
  {
    name: AxAIGoogleGeminiModel.GeminiRoboticsER16,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.0,
    completionTokenCostPer1M: 0.0,
  },
  {
    name: AxAIGoogleGeminiModel.Gemini25Pro,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 1.25,
    completionTokenCostPer1M: 10.0,
    cacheReadTokenCostPer1M: 0.125,
    cacheWriteTokenCostPer1M: 1.25,
    longContextThreshold: 200_000,
    longContextPromptTokenCostPer1M: 2.5,
    longContextCompletionTokenCostPer1M: 15.0,
    longContextCacheReadTokenCostPer1M: 0.25,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini20ProExp,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.0,
    completionTokenCostPer1M: 0.0,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini20FlashThinkingExp,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.0,
    completionTokenCostPer1M: 0.0,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini25Flash,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.3,
    completionTokenCostPer1M: 2.5,
    cacheReadTokenCostPer1M: 0.03,
    cacheWriteTokenCostPer1M: 0.3,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini25FlashNativeAudio,
    characterIsToken: false,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
    },
    audio: { input: true, output: true },
    contextWindow: 131_072,
    maxTokens: 8192,
  },
  {
    name: AxAIGoogleGeminiModel.Gemini25FlashLite,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.1,
    completionTokenCostPer1M: 0.4,
    cacheReadTokenCostPer1M: 0.01,
    cacheWriteTokenCostPer1M: 0.1,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini20Flash,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.1,
    completionTokenCostPer1M: 0.4,
    cacheReadTokenCostPer1M: 0.025,
    cacheWriteTokenCostPer1M: 0.1,
    supported: { structuredOutputs: true },
    isDeprecated: true,
    deprecatedOn: '2026-06-01',
  },

  {
    name: AxAIGoogleGeminiModel.Gemini20FlashLite,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.075,
    completionTokenCostPer1M: 0.3,
    supported: { structuredOutputs: true },
    isDeprecated: true,
    deprecatedOn: '2026-06-01',
  },
  {
    name: AxAIGoogleGeminiModel.Gemini15Flash,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.075,
    completionTokenCostPer1M: 0.3,
    supported: { structuredOutputs: true },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini15Flash8B,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.0375,
    completionTokenCostPer1M: 0.15,
    supported: { structuredOutputs: true },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini15Pro,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 1.25,
    completionTokenCostPer1M: 5.0,
    supported: { structuredOutputs: true },
  },
  {
    name: AxAIGoogleGeminiModel.Gemini1Pro,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.5,
    completionTokenCostPer1M: 1.5,
    supported: { structuredOutputs: true },
  },
  {
    name: AxAIGoogleGeminiModel.GeminiFlashLatest,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.3,
    completionTokenCostPer1M: 2.5,
    cacheReadTokenCostPer1M: 0.03,
    cacheWriteTokenCostPer1M: 0.3,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIGoogleGeminiModel.GeminiFlashLiteLatest,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 0.1,
    completionTokenCostPer1M: 0.4,
    cacheReadTokenCostPer1M: 0.01,
    cacheWriteTokenCostPer1M: 0.1,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
  {
    name: AxAIGoogleGeminiModel.GeminiProLatest,
    currency: 'usd',
    characterIsToken: false,
    promptTokenCostPer1M: 1.25,
    completionTokenCostPer1M: 10.0,
    cacheReadTokenCostPer1M: 0.125,
    cacheWriteTokenCostPer1M: 1.25,
    longContextThreshold: 200_000,
    longContextPromptTokenCostPer1M: 2.5,
    longContextCompletionTokenCostPer1M: 15.0,
    longContextCacheReadTokenCostPer1M: 0.25,
    supported: {
      thinkingBudget: true,
      showThoughts: true,
      structuredOutputs: true,
    },
  },
];
